import NextImage from "next/image";

import { SVGSprite } from "@/components/Atoms";
import Typography from "@/foundation/Typography/V2";

import { classNameGenerator } from "@/utils";

import { useAppSelector } from "@/hooks";

import styles from "./AppBannerSection.module.scss";

interface AppBannerSectionProps {}

const AppBannerSection: React.FC<AppBannerSectionProps> = () => {
  const { data: powerBootCampPageData } = useAppSelector(
    (state) => state.bootCamp
  );

  if(!powerBootCampPageData?.appBannerSection)
    return <></>

  const { heading, benefitsList, ctaText, imageLink, ctaData } =
    powerBootCampPageData?.appBannerSection || {};

  const { redirectToDashPage, dashIntermediatePage, shyftIntermediatePage } =
    ctaData || {};
  const cls = classNameGenerator(styles);

  return (
    <section id="AppBannerSection">
      <div className={cls("AppBannerSection")}>
        <div className={cls("AppBannerWrapper")}>
          <div className={cls("topSection")}>
            <div className={cls("mobileHeadingContainer")}>
              <Typography variant="heading5" className={cls("headingMobile")}>
                Download the{" "}
                <Typography variant="span" className={cls("spanText")}>
                  Shyft App
                </Typography>{" "}
                for all your health needs
              </Typography>
            </div>
            <div className={cls("imageWrapper")}>
              <NextImage
                fill={true}
                src={imageLink}
                alt="mobile screenshot"
                className={cls("screenshotImage")}
              />
            </div>
            <div className={cls("appDownLoadSection")}>
              <Typography variant="heading5" className={cls("heading")}>
                Download the{" "}
                <Typography variant="span" className={cls("spanText")}>
                  Shyft App
                </Typography>{" "}
                for all your health needs
              </Typography>

              <div className={cls("appDownload")}>
                <Typography
                  className={cls("appLink")}
                  variant="link1"
                  href="https://play.google.com/store/apps/details?id=com.mindhouse"
                  target="_blank"
                >
                  <img
                    className={cls("playStore")}
                    src="https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2023-09/play-store-fccb75cd67ea4a42b034b8fd49a30108.png"
                    alt="playstore"
                  />
                </Typography>
                <Typography
                  className={cls("appLink")}
                  variant="link1"
                  href="https://apps.apple.com/in/app/shyft-health/id1484471377"
                  target="_blank"
                >
                  <img
                    className={cls("appStore")}
                    src="https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2023-09/app-store-aad52723e2ef40a0b18acb2f0acb4471.png"
                    alt="appstore"
                  />
                </Typography>
              </div>
            </div>
          </div>
          <div className={cls("bottomSection")}>
            <div className={cls("freeTextContainer")}>FREE</div>
            <Typography
              variant="heading6"
              className={cls("heading")}
              dangerouslySetInnerHTML={{ __html: heading }}
            />
            <div className={cls("benefitSection")}>
              {benefitsList?.map((item: any) => {
                return (
                  <div key={item?.label} className={cls("benefitItem")}>
                    <SVGSprite icon={item?.icon} />
                    <Typography
                      variant="paragraph4"
                      className={cls("benefitText")}
                    >
                      {item?.label}
                    </Typography>
                  </div>
                );
              })}
            </div>
            <Typography
              variant="link2"
              className={cls("ctaButton")}
              // Data attributes
              href={
                redirectToDashPage
                  ? dashIntermediatePage
                  : shyftIntermediatePage ||
                    "#tally-open=wvr20v&tally-layout=modal&tally-width=800&tally-hide-title=1"
              }
            >
              <SVGSprite icon="icon-whatsapp" fill="#054F31" />
              <Typography variant="paragraph4" className={cls("ctaText")}>
                {ctaText}
              </Typography>
            </Typography>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppBannerSection;
